var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isGenerating && _vm.perGeneMode
      ? _c("div", { staticClass: "generation-status-fixed" }, [
          _vm._v(
            " (Generating protocol: (" +
              _vm._s(_vm.elapsedTime) +
              ") " +
              _vm._s(_vm.currentGeneName || "...") +
              " Remaining genes " +
              _vm._s(_vm.remainingGenesCount) +
              " (" +
              _vm._s(_vm.remainingGeneSymbols.join(", ")) +
              ")) "
          ),
        ])
      : _vm._e(),
    _vm.showWelcomePopup
      ? _c("div", { staticClass: "welcome-popup-overlay" }, [
          _c("div", { staticClass: "welcome-popup" }, [
            _c("div", { staticClass: "welcome-popup-header" }, [
              _c("h3", [_vm._v("Welcome to CFDE-DESIGN")]),
              _c(
                "button",
                {
                  staticClass: "close-btn",
                  on: { click: _vm.closeWelcomePopup },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "welcome-popup-content" }, [
              _c("p", [
                _vm._v(
                  "This tool helps you generate experiment protocols for validating genes against your hypothesis. Here's what you need to get started:"
                ),
              ]),
              _c("div", { staticClass: "welcome-requirements" }, [
                !_vm.urlHasGenes && !_vm.urlHasHypothesis
                  ? _c("div", { staticClass: "requirement-item" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "requirement-content" }, [
                        _c("h4", [_vm._v("Get Started with CFDE-REVEAL")]),
                        _c("p", [
                          _vm._v(
                            "To generate experiment protocols, you'll need genes and a hypothesis. We recommend starting with "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.setSimpleLink(
                                  "/r/factor_base_reveal"
                                ),
                                target: "_blank",
                              },
                            },
                            [_vm._v("CFDE-REVEAL")]
                          ),
                          _vm._v(
                            " to generate a gene set based on your research interest."
                          ),
                        ]),
                        _vm._m(1),
                        _c("ul", [
                          _c("li", [
                            _vm._v("Use "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.setSimpleLink(
                                    "/r/factor_base_reveal"
                                  ),
                                  target: "_blank",
                                },
                              },
                              [_vm._v("CFDE-REVEAL")]
                            ),
                            _vm._v(
                              " to explore gene expression signatures and generate a hypothesis"
                            ),
                          ]),
                          _c("li", [
                            _vm._v("Then use "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.kcURL("/r/cfde_explore"),
                                  target: "_blank",
                                },
                              },
                              [_vm._v("CFDE-EXPLORE")]
                            ),
                            _vm._v(" to prepare your genes"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "Finally, return here to generate experiment protocols"
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm.urlHasGenes && !_vm.urlHasHypothesis
                  ? _c("div", { staticClass: "requirement-item" }, [
                      _vm._m(2),
                      _c("div", { staticClass: "requirement-content" }, [
                        _vm._m(3),
                        _c("p", [
                          _vm._v(
                            "Great! We found genes in your URL parameters. However, to generate experiment protocols, you also need a hypothesis."
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [
                            _vm._v("We recommend using "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getExploreUrlWithGenes(),
                                  target: "_blank",
                                },
                              },
                              [_vm._v("CFDE-EXPLORE")]
                            ),
                            _vm._v(" to:"),
                          ]),
                        ]),
                        _vm._m(4),
                      ]),
                    ])
                  : _vm.urlHasGenes && _vm.urlHasHypothesis
                  ? _c("div", { staticClass: "requirement-item found" }, [
                      _vm._m(5),
                      _c("div", { staticClass: "requirement-content" }, [
                        _vm._m(6),
                        _c("p", [
                          _vm._v(
                            "Perfect! You have both genes and a hypothesis. You're ready to generate experiment protocols."
                          ),
                        ]),
                        _vm._m(7),
                        _vm._m(8),
                        _vm.urlHasResearchContext
                          ? _c(
                              "p",
                              {
                                staticStyle: {
                                  "margin-top": "12px",
                                  color: "#28a745",
                                },
                              },
                              [
                                _c("strong", [_vm._v("✓ Research Context:")]),
                                _vm._v(
                                  " Your research context has been loaded and will be used in protocol generation. "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "welcome-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.closeWelcomePopup },
                  },
                  [_vm._v("Got it, let's start!")]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "upper-layout" }, [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "hypothesis-container section-wrapper",
            attrs: { id: "hypothesis-section" },
          },
          [
            _vm._m(9),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("h5", [_vm._v("Research Context (Optional)")]),
                _c("div", { staticClass: "textarea-container" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.researchContext,
                        expression: "researchContext",
                      },
                    ],
                    staticClass: "hypothesis-textarea",
                    attrs: {
                      placeholder: "Enter your research context...",
                      rows: "3",
                    },
                    domProps: { value: _vm.researchContext },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.researchContext = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("h5", [_vm._v("Hypothesis")]),
                _c("div", { staticClass: "textarea-container" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phenotypeSearch,
                        expression: "phenotypeSearch",
                      },
                    ],
                    staticClass: "hypothesis-textarea",
                    attrs: {
                      placeholder: "Enter your hypothesis...",
                      rows: "3",
                    },
                    domProps: { value: _vm.phenotypeSearch },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.phenotypeSearch = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "hypothesis-content",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "additional-notes",
                    staticStyle: { "margin-bottom": "20px" },
                  },
                  [
                    _c("h5", [_vm._v("Experiment Constraints (Optional)")]),
                    _c("div", { staticClass: "notes-section" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.experimentNotes,
                            expression: "experimentNotes",
                          },
                        ],
                        staticClass: "notes-textarea",
                        attrs: {
                          id: "experiment-notes",
                          placeholder:
                            "Add any specific requirements, preferences, or additional considerations for your experiment...",
                          rows: "4",
                        },
                        domProps: { value: _vm.experimentNotes },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.experimentNotes = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "configuration-header",
                    on: { click: _vm.toggleConfigurationSection },
                  },
                  [
                    _c("h5", [
                      _c("span", { staticClass: "configuration-toggle" }, [
                        _vm._v(
                          _vm._s(_vm.showConfigurationSection ? "−" : "+")
                        ),
                      ]),
                      _vm._v(" Advanced Experiment parameters"),
                    ]),
                  ]
                ),
                _vm.showConfigurationSection
                  ? _c("div", { staticClass: "configuration-content" }, [
                      _vm._m(10),
                      _c("div", { staticClass: "experimental-parameters" }, [
                        _c("h5", [_vm._v("Experimental Parameters")]),
                        _c("div", { staticClass: "parameters-grid" }, [
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Assay Types")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.assayTypes = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.assayTypes = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedAssayTypes.length > 0
                                            ? `${_vm.selectedAssayTypes.length} selected`
                                            : "Choose assay types..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.assayTypes
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.assay_types.categories,
                                        function (assays, category) {
                                          return _c(
                                            "div",
                                            {
                                              key: category,
                                              staticClass: "category-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "category-header",
                                                },
                                                [_vm._v(_vm._s(category))]
                                              ),
                                              _vm._l(assays, function (assay) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: assay.id,
                                                    staticClass:
                                                      "checkbox-item",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectedAssayTypes,
                                                          expression:
                                                            "selectedAssayTypes",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        id: "assay-" + assay.id,
                                                      },
                                                      domProps: {
                                                        value:
                                                          category +
                                                          ":" +
                                                          assay.label,
                                                        checked: Array.isArray(
                                                          _vm.selectedAssayTypes
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectedAssayTypes,
                                                              category +
                                                                ":" +
                                                                assay.label
                                                            ) > -1
                                                          : _vm.selectedAssayTypes,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectedAssayTypes,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v =
                                                                category +
                                                                ":" +
                                                                assay.label,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectedAssayTypes =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectedAssayTypes =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.selectedAssayTypes =
                                                              $$c
                                                          }
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "assay-" + assay.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(assay.label)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedAssayTypes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedAssayTypes,
                                    function (assayType) {
                                      return _c(
                                        "div",
                                        {
                                          key: assayType,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(assayType.split(":")[1])
                                            ),
                                          ]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeAssayType(
                                                    assayType
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Cell Types")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.cellTypes = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.cellTypes = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedCellTypes.length > 0
                                            ? `${_vm.selectedCellTypes.length} selected`
                                            : "Choose cell types..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.cellTypes
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.cell_types.groups,
                                        function (group) {
                                          return _c(
                                            "div",
                                            {
                                              key: group.group,
                                              staticClass: "group-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "group-header" },
                                                [_vm._v(_vm._s(group.group))]
                                              ),
                                              group.options
                                                ? _vm._l(
                                                    group.options,
                                                    function (option) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: option.id,
                                                          staticClass:
                                                            "checkbox-item",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.selectedCellTypes,
                                                                expression:
                                                                  "selectedCellTypes",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                              id:
                                                                "cell-" +
                                                                option.id,
                                                            },
                                                            domProps: {
                                                              value:
                                                                group.group +
                                                                ":" +
                                                                option.label,
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.selectedCellTypes
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedCellTypes,
                                                                      group.group +
                                                                        ":" +
                                                                        option.label
                                                                    ) > -1
                                                                  : _vm.selectedCellTypes,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectedCellTypes,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      group.group +
                                                                      ":" +
                                                                      option.label,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectedCellTypes =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectedCellTypes =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectedCellTypes =
                                                                    $$c
                                                                }
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "cell-" +
                                                                  option.id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  option.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                              group.subgroups
                                                ? _vm._l(
                                                    group.subgroups,
                                                    function (subgroup) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: subgroup.label,
                                                          staticClass:
                                                            "subgroup-section",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "subgroup-header",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  subgroup.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            subgroup.options,
                                                            function (option) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: option.id,
                                                                  staticClass:
                                                                    "checkbox-item",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.selectedCellTypes,
                                                                          expression:
                                                                            "selectedCellTypes",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                      id:
                                                                        "cell-" +
                                                                        option.id,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        group.group +
                                                                        ":" +
                                                                        subgroup.label +
                                                                        ":" +
                                                                        option.label,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.selectedCellTypes
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.selectedCellTypes,
                                                                              group.group +
                                                                                ":" +
                                                                                subgroup.label +
                                                                                ":" +
                                                                                option.label
                                                                            ) >
                                                                            -1
                                                                          : _vm.selectedCellTypes,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.selectedCellTypes,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                group.group +
                                                                                ":" +
                                                                                subgroup.label +
                                                                                ":" +
                                                                                option.label,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.selectedCellTypes =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.selectedCellTypes =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.selectedCellTypes =
                                                                              $$c
                                                                          }
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "cell-" +
                                                                          option.id,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.label
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedCellTypes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedCellTypes,
                                    function (cellType) {
                                      return _c(
                                        "div",
                                        {
                                          key: cellType,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(cellType.split(":").pop())
                                            ),
                                          ]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeCellType(
                                                    cellType
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "filter-section" }, [
                            _c("h5", [_vm._v("Assay Readouts")]),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-container",
                                on: {
                                  mouseenter: function ($event) {
                                    _vm.showDropdowns.readouts = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showDropdowns.readouts = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { staticClass: "dropdown-toggle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedReadouts.length > 0
                                            ? `${_vm.selectedReadouts.length} selected`
                                            : "Choose readouts..."
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.showDropdowns.readouts
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown-content" },
                                      _vm._l(
                                        _vm.assay_readouts.options,
                                        function (readout) {
                                          return _c(
                                            "div",
                                            {
                                              key: readout.label,
                                              staticClass: "checkbox-item",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectedReadouts,
                                                    expression:
                                                      "selectedReadouts",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id:
                                                    "readout-" + readout.label,
                                                },
                                                domProps: {
                                                  value: readout.label,
                                                  checked: Array.isArray(
                                                    _vm.selectedReadouts
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedReadouts,
                                                        readout.label
                                                      ) > -1
                                                    : _vm.selectedReadouts,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.selectedReadouts,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = readout.label,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedReadouts =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedReadouts =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedReadouts = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "readout-" +
                                                      readout.label,
                                                  },
                                                },
                                                [_vm._v(_vm._s(readout.label))]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm.selectedReadouts.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "selected-items" },
                                  _vm._l(
                                    _vm.selectedReadouts,
                                    function (readout) {
                                      return _c(
                                        "div",
                                        {
                                          key: readout,
                                          staticClass: "selected-item",
                                        },
                                        [
                                          _c("span", [_vm._v(_vm._s(readout))]),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeReadout(
                                                    readout
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "experimental-constraints" }, [
                        _c("h5", [_vm._v("Experimental Constraints")]),
                        _c("div", { staticClass: "constraints-grid" }, [
                          _c("div", { staticClass: "constraint-section" }, [
                            _c(
                              "label",
                              { attrs: { for: "throughput-select" } },
                              [_vm._v("Throughput")]
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedThroughput,
                                    expression: "selectedThroughput",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "throughput-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedThroughput = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose throughput..."),
                                ]),
                                _c("option", { attrs: { value: "low" } }, [
                                  _vm._v("Low (1-5 conditions)"),
                                ]),
                                _c("option", { attrs: { value: "medium" } }, [
                                  _vm._v("Medium (6-30)"),
                                ]),
                                _c("option", { attrs: { value: "high" } }, [
                                  _vm._v("High (30+)"),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "constraint-section" }, [
                            _c("label", { attrs: { for: "species-select" } }, [
                              _vm._v("Target Species"),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSpecies,
                                    expression: "selectedSpecies",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "species-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedSpecies = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose species..."),
                                ]),
                                _c("option", { attrs: { value: "human" } }, [
                                  _vm._v("Human"),
                                ]),
                                _c("option", { attrs: { value: "rodents" } }, [
                                  _vm._v("Rodents"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "human-rodents" } },
                                  [_vm._v("Human + Rodents")]
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "constraint-section" }, [
                            _c(
                              "label",
                              { attrs: { for: "timebudget-select" } },
                              [_vm._v("Project Timeline")]
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedTimeBudget,
                                    expression: "selectedTimeBudget",
                                  },
                                ],
                                staticClass: "constraint-select",
                                attrs: { id: "timebudget-select" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedTimeBudget = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v("Choose timeline..."),
                                ]),
                                _c("option", { attrs: { value: "2-3weeks" } }, [
                                  _vm._v("2-3 weeks"),
                                ]),
                                _c(
                                  "option",
                                  { attrs: { value: "1-2months" } },
                                  [_vm._v("1-2 months")]
                                ),
                                _c("option", { attrs: { value: "quarter" } }, [
                                  _vm._v("Quarter-long"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
            _c("div", { attrs: { id: "planner-search-ui" } }, [
              _c(
                "div",
                {
                  staticClass: "genes-display-section",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm._m(11),
                  _c("small", { staticClass: "format-suggestion" }, [
                    _vm._v(
                      "(Switch to Edit mode to enter genes manually. Enter genes separated by commas (e.g., GENE1, GENE2, GENE3)). Click gene chips to select genes for grouping. "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm",
                        class: _vm.genesEditMode
                          ? "btn-outline-secondary"
                          : "btn-primary",
                        staticStyle: {
                          padding: "4px 12px",
                          "font-size": "12px",
                          top: "-15px",
                          position: "relative",
                          right: "-10px",
                          float: "right",
                        },
                        on: {
                          click: function ($event) {
                            _vm.genesEditMode = !_vm.genesEditMode
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.genesEditMode ? "View" : "Edit list") +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  !_vm.genesEditMode
                    ? _c(
                        "div",
                        {
                          staticClass: "genes-view-mode",
                          staticStyle: {
                            padding: "8px",
                            background: "#f8f9fa",
                            "border-radius": "6px",
                            border: "1px solid #dee2e6",
                            "max-height": "200px",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _vm.organizedGenes.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "gene-chips-container",
                                  staticStyle: {
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                    gap: "4px",
                                  },
                                },
                                _vm._l(_vm.organizedGenes, function (gene) {
                                  return _c(
                                    "span",
                                    {
                                      key: gene.symbol,
                                      staticClass: "gene-chip",
                                      class: {
                                        "gene-chip-selected": gene.isSelected,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleGeneSelection(
                                            gene.symbol
                                          )
                                        },
                                        mouseenter: function ($event) {
                                          _vm.hoveredGene = gene.symbol
                                        },
                                        mouseleave: function ($event) {
                                          _vm.hoveredGene = null
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "gene-chip-text" },
                                        [_vm._v(_vm._s(gene.symbol))]
                                      ),
                                      gene.isSelected &&
                                      _vm.hoveredGene === gene.symbol
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "gene-chip-remove",
                                              attrs: {
                                                title: "Click to unselect",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleGeneSelection(
                                                    gene.symbol
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" × ")]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c(
                                "p",
                                {
                                  staticStyle: {
                                    margin: "0",
                                    color: "#999",
                                    "font-size": "13px",
                                    "font-style": "italic",
                                    padding: "8px 0",
                                  },
                                },
                                [
                                  _vm._v(
                                    " No genes added. Click Edit to add genes. "
                                  ),
                                ]
                              ),
                        ]
                      )
                    : _c("div", { staticClass: "genes-edit-mode" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.genesListString,
                              expression: "genesListString",
                            },
                          ],
                          staticClass: "hypothesis-textarea",
                          attrs: {
                            placeholder: "e.g., TP53, BRCA1, MYC, EGFR",
                            rows: "3",
                          },
                          domProps: { value: _vm.genesListString },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.genesListString = $event.target.value
                              },
                              _vm.updateGenesListFromString,
                            ],
                          },
                        }),
                      ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "gene-utility-section gene-utility-section-centered",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm.genesList.length > 0 &&
                  (_vm.phenotypeSearch.trim() || _vm.urlHasGenes)
                    ? _c("research-gene-set-utility", {
                        attrs: {
                          genes: _vm.genesList,
                          hypothesis: _vm.phenotypeSearch,
                          "research-context": _vm.researchContext,
                          "selected-genes": _vm.selectedGenes,
                          "assay-types": _vm.selectedAssayTypes,
                          "cell-types": _vm.selectedCellTypes,
                          readouts: _vm.selectedReadouts,
                          throughput: _vm.selectedThroughput,
                          species: _vm.selectedSpecies,
                          "time-budget": _vm.selectedTimeBudget,
                          "experiment-notes": _vm.experimentNotes,
                          "llm-config": {
                            //llm: sectionConfigs.llm || 'gemini',
                            //model: sectionConfigs.model || (sectionConfigs.llm === 'openai' ? 'gpt-5-mini' : 'gemini-2.5-flash-lite')
                          },
                          "hide-buttons": false,
                          "show-only-group-and-tier": true,
                          "show-review-button": true,
                        },
                        on: {
                          "update:selectedGenes": _vm.handleGenesSelected,
                          "grouped-genes": _vm.handleGroupedGenes,
                          "review-generate-per-groups":
                            _vm.onReviewGeneratePerGroups,
                          "review-generate": _vm.draftValidationPlan,
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "12px",
                            background: "#fff3cd",
                            "border-radius": "6px",
                            border: "1px solid #ffc107",
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                margin: "0",
                                color: "#856404",
                                "font-size": "14px",
                              },
                            },
                            [
                              _c("strong", [_vm._v("Note:")]),
                              _vm._v(
                                " Add genes (e.g. from URL parameters or manually) to enable Group and Tier Genes. "
                              ),
                            ]
                          ),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _c("div"),
    _c("div", [
      !(
        _vm.genesList &&
        _vm.genesList.length > 0 &&
        (_vm.phenotypeSearch.trim() || _vm.urlHasGenes)
      )
        ? _c("div", { staticClass: "action-buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.draftValidationPlan },
              },
              [_vm._v(" Review & Generate Experiment Plan ")]
            ),
          ])
        : _vm._e(),
    ]),
    _vm.showExperimentSummary
      ? _c(
          "div",
          {
            staticClass: "section-wrapper",
            attrs: { id: "planner-search-draft" },
          },
          [
            _vm._m(12),
            _c("div", { staticClass: "section-content" }, [
              _c("div", { staticClass: "search-summary" }, [
                _c("div", { staticClass: "summary-card" }, [
                  _c("div", { staticClass: "config-summary" }, [
                    _c("h6", [_vm._v("Configuration Summary")]),
                    _c("div", { staticClass: "config-grid" }, [
                      _vm.phenotypeSearch.trim() !== ""
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Hypothesis:")]),
                            _vm._v(" " + _vm._s(_vm.phenotypeSearch) + " "),
                          ])
                        : _vm._e(),
                      _vm.selectedGenes.length > 0
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Selected Genes:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedGenes.length) +
                                " gene" +
                                _vm._s(
                                  _vm.selectedGenes.length > 1 ? "s" : ""
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "gene-list" }, [
                              _vm._v(
                                "(" + _vm._s(_vm.selectedGenes.join(", ")) + ")"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.selectedAssayTypes.length > 0
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Assay Types:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedAssayTypes
                                    .map((at) => at.split(":")[1] || "")
                                    .join(", ")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.selectedCellTypes.length > 0
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Cell Types:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedCellTypes
                                    .map((ct) => ct.split(":").pop() || "")
                                    .join(", ")
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.selectedReadouts.length > 0
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Readouts:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedReadouts.join(", ")) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _vm.selectedThroughput ||
                      _vm.selectedSpecies ||
                      _vm.selectedTimeBudget
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Constraints:")]),
                            _vm.selectedThroughput
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.selectedThroughput)),
                                ])
                              : _vm._e(),
                            _vm.selectedSpecies
                              ? _c("span", [
                                  _vm._v(" • " + _vm._s(_vm.selectedSpecies)),
                                ])
                              : _vm._e(),
                            _vm.selectedTimeBudget
                              ? _c("span", [
                                  _vm._v(
                                    " • " + _vm._s(_vm.selectedTimeBudget)
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.experimentNotes.trim() !== ""
                        ? _c("div", { staticClass: "config-item" }, [
                            _c("strong", [_vm._v("Notes:")]),
                            _vm._v(" " + _vm._s(_vm.experimentNotes) + " "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "search-context" }, [
                    _c("h6", [_vm._v("Experiment Plan")]),
                    _vm.selectedGenes.length > 0
                      ? _c("div", { staticClass: "experiment-plan-info" }, [
                          _c("p", [
                            _vm._v(
                              "Choose how to generate experiment plans with your selected genes:"
                            ),
                          ]),
                          _c("div", { staticClass: "gene-strategy-options" }, [
                            _c("div", { staticClass: "strategy-option" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.geneExperimentStrategy,
                                    expression: "geneExperimentStrategy",
                                  },
                                ],
                                staticClass: "strategy-radio",
                                attrs: {
                                  type: "radio",
                                  id: "individual-genes",
                                  value: "individual",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.geneExperimentStrategy,
                                    "individual"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.geneExperimentStrategy = "individual"
                                  },
                                },
                              }),
                              _vm._m(13),
                            ]),
                            _c("div", { staticClass: "strategy-option" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.geneExperimentStrategy,
                                    expression: "geneExperimentStrategy",
                                  },
                                ],
                                staticClass: "strategy-radio",
                                attrs: {
                                  type: "radio",
                                  id: "all-genes-together",
                                  value: "all_together",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.geneExperimentStrategy,
                                    "all_together"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.geneExperimentStrategy = "all_together"
                                  },
                                },
                              }),
                              _vm._m(14),
                            ]),
                            _vm.groupedGenes &&
                            _vm.groupedGenes.tiers &&
                            _vm.groupedGenes.tiers.length > 0
                              ? _c("div", { staticClass: "strategy-option" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.geneExperimentStrategy,
                                        expression: "geneExperimentStrategy",
                                      },
                                    ],
                                    staticClass: "strategy-radio",
                                    attrs: {
                                      type: "radio",
                                      id: "per-gene-groups",
                                      value: "per_groups",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.geneExperimentStrategy,
                                        "per_groups"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.geneExperimentStrategy =
                                          "per_groups"
                                      },
                                    },
                                  }),
                                  _vm._m(15),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "strategy-description" }, [
                            _vm.geneExperimentStrategy === "individual"
                              ? _c("p", [
                                  _c("em", [
                                    _vm._v(
                                      "This will generate " +
                                        _vm._s(_vm.selectedGenes.length) +
                                        " separate experiment plan" +
                                        _vm._s(
                                          _vm.selectedGenes.length > 1
                                            ? "s"
                                            : ""
                                        ) +
                                        " - one for each gene (" +
                                        _vm._s(_vm.selectedGenes.join(", ")) +
                                        ") in combination with your hypothesis."
                                    ),
                                  ]),
                                ])
                              : _vm.geneExperimentStrategy === "all_together"
                              ? _c("p", [
                                  _c("em", [
                                    _vm._v(
                                      "This will generate one comprehensive experiment plan that tests all selected genes (" +
                                        _vm._s(_vm.selectedGenes.join(", ")) +
                                        ") together in combination with your hypothesis."
                                    ),
                                  ]),
                                ])
                              : _vm.geneExperimentStrategy === "per_groups" &&
                                _vm.groupedGenes &&
                                _vm.groupedGenes.tiers
                              ? _c("p", [
                                  _c("em", [
                                    _vm._v(
                                      "This will generate experiment plans for each selected gene group. "
                                    ),
                                    _vm.groupedGenes.tiers
                                      ? _c("span", [
                                          _vm._v(
                                            " Selected: " +
                                              _vm._s(_vm.selectedGroupCount) +
                                              " of " +
                                              _vm._s(
                                                _vm.groupedGenes.tiers.reduce(
                                                  (sum, tier) =>
                                                    sum + tier.groups.length,
                                                  0
                                                )
                                              ) +
                                              " groups across " +
                                              _vm._s(
                                                _vm.groupedGenes.tiers.length
                                              ) +
                                              " tier(s). Unselect groups in the Group and Tier dialog to exclude them. "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                        ])
                      : _c(
                          "div",
                          { staticClass: "no-genes-selected warning-box" },
                          [_vm._m(16)]
                        ),
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.searchPlanText) },
                    }),
                  ]),
                  _c("div", { staticClass: "experiment-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          disabled:
                            _vm.isGenerating ||
                            _vm.selectedGenes.length === 0 ||
                            (_vm.geneExperimentStrategy === "per_groups" &&
                              (!_vm.groupedGenes ||
                                !_vm.groupedGenes.tiers ||
                                _vm.groupedGenes.tiers.length === 0 ||
                                _vm.selectedGroupCount === 0)),
                        },
                        on: { click: _vm.generateExperiment },
                      },
                      [
                        _vm.isGenerating
                          ? _c("span", { staticClass: "loading-spinner-small" })
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isGenerating
                                ? `Generating Experiments (${_vm.elapsedTime})`
                                : _vm.selectedGenes.length === 0
                                ? "⚠️ Select Genes First"
                                : _vm.geneExperimentStrategy === "per_groups" &&
                                  (!_vm.groupedGenes ||
                                    !_vm.groupedGenes.tiers ||
                                    _vm.groupedGenes.tiers.length === 0)
                                ? "⚠️ Generate Gene Groups First"
                                : _vm.geneExperimentStrategy === "per_groups" &&
                                  _vm.selectedGroupCount === 0
                                ? "⚠️ Select at Least One Group"
                                : "Generate Experiment"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm.finalExperimentResults.length > 0 || _vm.isGenerating
      ? _c(
          "div",
          {
            staticClass: "section-wrapper",
            attrs: { id: "planner-search-results" },
          },
          [
            _c("div", { staticClass: "protocol-header" }, [
              _c("h4", [_vm._v("Generated Experiment Protocol")]),
              _c("div", { staticClass: "protocol-actions" }, [
                !_vm.isGenerating
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary download-btn",
                        on: { click: _vm.downloadExperiment },
                      },
                      [_vm._v(" Download Experiment Plan ")]
                    )
                  : _vm._e(),
                !_vm.isGenerating
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-success citation-btn",
                        on: { click: _vm.showCitationInfo },
                      },
                      [_vm._v(" Citation Information ")]
                    )
                  : _vm._e(),
                !_vm.isGenerating
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-alert",
                        on: {
                          click: function ($event) {
                            _vm.showDisclaimer = !_vm.showDisclaimer
                          },
                        },
                      },
                      [_vm._v(" Important Disclaimer ")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm.isGenerating && _vm.perGeneMode
              ? _c("div", { staticClass: "loading-message" }, [
                  _c("p", [
                    _vm._v(
                      "Generating per-gene protocols (" +
                        _vm._s(_vm.perGeneCompleted + 1) +
                        " / " +
                        _vm._s(_vm.perGeneTotal) +
                        ") · Remaining: " +
                        _vm._s(_vm.remainingGenesCount) +
                        " · Current: " +
                        _vm._s(_vm.currentGeneName || "...") +
                        " · " +
                        _vm._s(_vm.elapsedTime)
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.isGenerating
              ? _c("div", { staticClass: "loading-message" }, [
                  _c("p", [_vm._v("Creating your experiment protocol...")]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "experiment-results" }, [
              _vm.showDisclaimer
                ? _c("div", { staticClass: "experiment-disclaimer" }, [
                    _vm._m(17),
                    _vm._m(18),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "experiment-plan" },
                [
                  _vm._l(
                    _vm.finalExperimentResults,
                    function (experiment, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "experiment-card" },
                        [
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Biological Assertion"),
                            ]),
                            _c("div", { staticClass: "assertion-content" }, [
                              _c("div", { staticClass: "hypothesis" }, [
                                _c("strong", [_vm._v("Hypothesis:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.biological_assertion.hypothesis
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "mechanism" }, [
                                _c("strong", [_vm._v("Mechanism:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.biological_assertion.mechanism
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "phenotype" }, [
                                _c("strong", [_vm._v("Phenotype:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.biological_assertion.phenotype
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "gene" }, [
                                _c("strong", [_vm._v("Gene:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.biological_assertion.gene
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Suggested Experiment"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "experiment-description" },
                              [
                                Array.isArray(
                                  experiment.suggested_experiment.experiment
                                )
                                  ? [
                                      _c(
                                        "ul",
                                        { staticClass: "setup-list" },
                                        _vm._l(
                                          experiment.suggested_experiment
                                            .experiment,
                                          function (item, idx) {
                                            return _c(
                                              "li",
                                              { key: `se-${idx}` },
                                              [_vm._v(_vm._s(item))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            experiment.suggested_experiment
                                              .experiment
                                          ) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Why Validate"),
                            ]),
                            _c("div", { staticClass: "validation-reasons" }, [
                              _c(
                                "div",
                                { staticClass: "reason-item" },
                                [
                                  _c("strong", [_vm._v("Feasibility:")]),
                                  Array.isArray(
                                    experiment.Why_validate.feasibility
                                  )
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.Why_validate.feasibility,
                                            function (x, i) {
                                              return _c(
                                                "li",
                                                { key: `wvf-${i}` },
                                                [_vm._v(_vm._s(x))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            experiment.Why_validate.feasibility
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "reason-item" },
                                [
                                  _c("strong", [_vm._v("Impact:")]),
                                  Array.isArray(experiment.Why_validate.Impact)
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.Why_validate.Impact,
                                            function (x, i) {
                                              return _c(
                                                "li",
                                                { key: `wvi-${i}` },
                                                [_vm._v(_vm._s(x))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(experiment.Why_validate.Impact)
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "reason-item" },
                                [
                                  _c("strong", [_vm._v("Novelty:")]),
                                  Array.isArray(experiment.Why_validate.Novelty)
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.Why_validate.Novelty,
                                            function (x, i) {
                                              return _c(
                                                "li",
                                                { key: `wvn-${i}` },
                                                [_vm._v(_vm._s(x))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            experiment.Why_validate.Novelty
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Protocol Sketch"),
                            ]),
                            _c("div", { staticClass: "protocol-details" }, [
                              _c("div", { staticClass: "protocol-item" }, [
                                _c("strong", [_vm._v("Design:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(experiment.protocol_sketch.design) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "protocol-item" }, [
                                _c("strong", [_vm._v("Perturbation:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.protocol_sketch.perturbation
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "protocol-item" },
                                [
                                  _c("strong", [_vm._v("Readouts:")]),
                                  Array.isArray(
                                    experiment.protocol_sketch.readouts
                                  )
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.protocol_sketch.readouts,
                                            function (r, rIdx) {
                                              return _c(
                                                "li",
                                                { key: `ro-${rIdx}` },
                                                [_vm._v(_vm._s(r))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            experiment.protocol_sketch.readouts
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "protocol-item" },
                                [
                                  _c("strong", [_vm._v("Controls:")]),
                                  Array.isArray(
                                    experiment.protocol_sketch.controls
                                  )
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.protocol_sketch.controls,
                                            function (c, cIdx) {
                                              return _c(
                                                "li",
                                                { key: `ct-${cIdx}` },
                                                [_vm._v(_vm._s(c))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            experiment.protocol_sketch.controls
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "protocol-item" },
                                [
                                  _c("strong", [_vm._v("Analysis:")]),
                                  Array.isArray(
                                    experiment.protocol_sketch.analysis
                                  )
                                    ? [
                                        _c(
                                          "ul",
                                          { staticClass: "setup-list" },
                                          _vm._l(
                                            experiment.protocol_sketch.analysis,
                                            function (a, aIdx) {
                                              return _c(
                                                "li",
                                                { key: `an-${aIdx}` },
                                                [_vm._v(_vm._s(a))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            experiment.protocol_sketch.analysis
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Feasibility Details"),
                            ]),
                            _c("div", { staticClass: "feasibility-content" }, [
                              _c("div", { staticClass: "feasibility-item" }, [
                                _c("strong", [
                                  _vm._v("Required Capabilities:"),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "setup-list" },
                                  _vm._l(
                                    experiment.feasibility_details
                                      .required_capabilities,
                                    function (capability) {
                                      return _c("li", { key: capability }, [
                                        _vm._v(_vm._s(capability)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c("div", { staticClass: "feasibility-item" }, [
                                _c("strong", [_vm._v("Expected Timeline:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.feasibility_details
                                        .expected_timeline
                                    ) +
                                    " "
                                ),
                                _vm._m(19, true),
                              ]),
                              _c("div", { staticClass: "feasibility-item" }, [
                                _c("strong", [_vm._v("Estimated Conditions:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      experiment.feasibility_details
                                        .Estimated_conditions
                                    ) +
                                    " "
                                ),
                                _vm._m(20, true),
                              ]),
                              _c("div", { staticClass: "feasibility-item" }, [
                                _c("strong", [_vm._v("Required Materials:")]),
                                _c(
                                  "ul",
                                  { staticClass: "materials-list" },
                                  _vm._l(
                                    experiment.feasibility_details
                                      .required_materials,
                                    function (material) {
                                      return _c("li", { key: material }, [
                                        _vm._v(_vm._s(material)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Design Critique"),
                            ]),
                            _c("div", { staticClass: "critique-content" }, [
                              _c("div", { staticClass: "critique-section" }, [
                                _c("strong", [_vm._v("Strengths:")]),
                                _c(
                                  "ul",
                                  { staticClass: "critique-list strengths" },
                                  _vm._l(
                                    experiment.design_critique.strengths,
                                    function (strength) {
                                      return _c("li", { key: strength }, [
                                        _vm._v(_vm._s(strength)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c("div", { staticClass: "critique-section" }, [
                                _c("strong", [_vm._v("Limitations:")]),
                                _c(
                                  "ul",
                                  { staticClass: "critique-list limitations" },
                                  _vm._l(
                                    experiment.design_critique.limitations,
                                    function (limitation) {
                                      return _c("li", { key: limitation }, [
                                        _vm._v(_vm._s(limitation)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c("div", { staticClass: "critique-section" }, [
                                _c("strong", [
                                  _vm._v("Justification for Deviation:"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "justification-text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        experiment.design_critique
                                          .justification_for_deviation
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "critique-section" }, [
                                _c("strong", [
                                  _vm._v("Alternative Approaches:"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "alternatives" },
                                  _vm._l(
                                    experiment.design_critique
                                      .alternative_approaches,
                                    function (alt, altIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: `alt-${index}-${altIndex}`,
                                          staticClass: "alternative-item",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "alt-type" },
                                            [_vm._v(_vm._s(alt.type) + ":")]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(alt.suggestion) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c("div", { staticClass: "critique-section" }, [
                                _c("strong", [
                                  _vm._v("Strategic Recommendation:"),
                                ]),
                                _c("div", { staticClass: "strategic-rec" }, [
                                  _vm._v(
                                    _vm._s(
                                      experiment.design_critique
                                        .strategic_recommendation
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "experiment-section" }, [
                            _c("h6", { staticClass: "section-title" }, [
                              _vm._v("Provenance"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "provenance-text" },
                              [
                                Array.isArray(experiment.provenance)
                                  ? [
                                      _c(
                                        "ul",
                                        { staticClass: "setup-list" },
                                        _vm._l(
                                          experiment.provenance,
                                          function (p, pIdx) {
                                            return _c(
                                              "li",
                                              { key: `pv-${pIdx}` },
                                              [_vm._v(_vm._s(p))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : [_vm._v(_vm._s(experiment.provenance))],
                              ],
                              2
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  _vm.finalExperimentResults.length > 1
                    ? _c("div", { staticClass: "protocol-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary download-btn",
                            on: { click: _vm.downloadExperiment },
                          },
                          [_vm._v(" Download All Experiments ")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm.showCitationPopup
      ? _c(
          "div",
          {
            staticClass: "citation-popup-overlay",
            on: { click: _vm.hideCitationInfo },
          },
          [
            _c(
              "div",
              {
                staticClass: "citation-popup",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "citation-popup-header" }, [
                  _c("h4", [_vm._v("Citation Information")]),
                  _c(
                    "button",
                    {
                      staticClass: "citation-close-btn",
                      on: { click: _vm.hideCitationInfo },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _c("div", { staticClass: "citation-popup-content" }, [
                  _vm._m(21),
                  _vm._m(22),
                  _vm._m(23),
                  _vm._m(24),
                  _vm._m(25),
                  _c("p", [
                    _vm._v(
                      "Citation policies for each page or analysis on the Knowledge Center are available here: "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.setSimpleLink(
                            "https://cfdeknowledge.org/r/cfdekc_policies_citation"
                          ),
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "https://cfdeknowledge.org/r/cfdekc_policies_citation"
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "citation-popup-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.hideCitationInfo },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "requirement-icon" }, [
      _c("span", { staticClass: "info-icon" }, [_vm._v("ℹ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Next steps:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "requirement-icon" }, [
      _c("span", { staticClass: "check-icon" }, [_vm._v("✓")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _vm._v("Genes Found "),
      _c("span", { staticClass: "status-found" }, [_vm._v("✓ Found in URL")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("Generate a hypothesis from your genes")]),
      _c("li", [
        _vm._v("Generate relevance and novelty scores for your genes"),
      ]),
      _c("li", [_vm._v("Filter and rank candidate genes")]),
      _c("li", [_vm._v("Then return here to generate experiment protocols")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "requirement-icon" }, [
      _c("span", { staticClass: "check-icon" }, [_vm._v("✓")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _vm._v("Ready to Generate Protocols "),
      _c("span", { staticClass: "status-found" }, [
        _vm._v("✓ Genes & Hypothesis Found"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("What you can do:")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v("Review and configure experiment parameters (optional)"),
      ]),
      _c("li", [_vm._v("Select genes from the table below")]),
      _c("li", [
        _vm._v('Click "Review & Generate Experiment Plan" to create protocols'),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Experiment Configuration")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-guidance" }, [
      _c("p", [
        _c("strong", [_vm._v("💡 Tip:")]),
        _vm._v(
          " You can leave any input fields empty if you want the AI to determine the best options for your experiments. The AI will automatically select optimal assay types, cell types, and other parameters based on your hypothesis and data."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "align-items": "center",
          "margin-bottom": "8px",
        },
      },
      [_c("h5", { staticStyle: { margin: "0" } }, [_vm._v("Genes ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v("Review Your Selections & Generate Experiment Plan")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "strategy-label", attrs: { for: "individual-genes" } },
      [
        _c("strong", [_vm._v("Individual Gene Experiments")]),
        _c("small", [
          _vm._v("Generate separate experiment plans for each selected gene"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "strategy-label", attrs: { for: "all-genes-together" } },
      [
        _c("strong", [_vm._v("Combined Gene Experiment")]),
        _c("small", [
          _vm._v(
            "Generate one experiment plan that tests all selected genes together"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "strategy-label", attrs: { for: "per-gene-groups" } },
      [
        _c("strong", [_vm._v("Per Gene Group Experiments")]),
        _c("small", [
          _vm._v(
            "Generate experiment plans for each gene group from the grouping/tiering strategy"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "warning-content" }, [
      _c("p", [
        _c("strong", [_vm._v("Warning:")]),
        _vm._v(
          "⚠️ No genes selected. You must select at least 1 gene to generate experiment plans."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "disclaimer-header" }, [
      _c("h5", [_vm._v("⚠️ Important Disclaimer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "disclaimer-content" }, [
      _c("p", [
        _c("strong", [
          _vm._v(
            "This tool is designed to help generate testable experiment plans for hypothesis validation, not to provide definitive scientific guidance."
          ),
        ]),
      ]),
      _c("p", [_vm._v("Please note that:")]),
      _c("ul", [
        _c("li", [
          _vm._v(
            "These experiment plans are AI-generated suggestions and should be reviewed by qualified researchers"
          ),
        ]),
        _c("li", [
          _vm._v(
            "Plans may not align with current journal standards, field-specific requirements, or institutional protocols"
          ),
        ]),
        _c("li", [
          _vm._v(
            "Always consult with domain experts and follow established laboratory safety and ethical guidelines"
          ),
        ]),
        _c("li", [
          _vm._v(
            "Verify all technical details, protocols, and safety considerations before implementation"
          ),
        ]),
        _c("li", [
          _vm._v(
            "Consider your specific experimental context, resources, and constraints"
          ),
        ]),
      ]),
      _c("p", [
        _c("em", [
          _vm._v(
            "Use these suggestions as a starting point for discussion and planning, not as final experimental protocols."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "timeline-disclaimer" }, [
      _c("small", [
        _c("em", [
          _vm._v(
            "Please note these timelines are general estimates, not absolute predictions, and that timelines assume the user already has the animals/cells/experimental reagents in-hand and the appropriate animal and/or institutional protocols in place to conduct these experiments. All researchers should be responsible for conducting their experiments in accordance with ethical guidelines as required by their institution."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "conditions-disclaimer" }, [
      _c("small", [
        _c("em", [
          _vm._v(
            "Please note: These are general estimates. Researchers should perform a power calculation for each assay to determine the appropriate number of mice required for the experiment based on expected effect size, variability, and desired statistical power."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "If you use this tool in a scientific publication, presentation, or other output, please cite the CFDE Knowledge Center in the following format:"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "citation-format" }, [
      _c("p", [
        _vm._v("The Common Fund Data Ecosystem Knowledge Center ("),
        _c(
          "a",
          {
            attrs: { href: "https://www.cfdeknowledge.org", target: "_blank" },
          },
          [_vm._v("https://www.cfdeknowledge.org")]
        ),
        _vm._v(
          "), supported by NIH Office of the Director, Fund OT2OD036440. Year Month Date of access; URL of page cited. Specific identifiers/ accession numbers for datasets used."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Additional Citation Requirements:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "Users citing data and/or resources collected through other CFDE- or non-CFDE-generated studies should also cite all underlying studies comprising those datasets."
        ),
      ]),
      _c("li", [
        _vm._v(
          "All published datasets must be cited according to the associated publication, using DOIs and PMIDs when available."
        ),
      ]),
      _c("li", [
        _vm._v(
          "Data reused from third-party repositories must adhere to their citation policies."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Citation Policies:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }